export default __webpack_public_path__ + "static/media/hiding-octopus.24ac3d14.png";